import eruda from 'eruda';

/**
 * eruda デバッグコンソール
 */
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  const config = useRuntimeConfig();
  const appEnv = config.public.env;
  const __DEBUG__ = ['dev', 'stg'].includes(appEnv as string);

  if (!__DEBUG__) return;

  if (document.querySelector('#eruda')) return;

  eruda.init();
});
